// Use ClientEnum for clientName context in Volo Pass/membership mutations
const ClientEnum = Object.freeze({
  MEMBERSHIP: 'membership',
  WEB: 'web',
});

export default ClientEnum;
